import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'cerp_cookie_consent';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay to avoid banner flash on page load
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      accepted: true,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const handleDismiss = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-40 animate-in slide-in-from-bottom-4 duration-300"
      data-testid="cookie-consent-banner"
    >
      <div className="bg-slate-900/95 backdrop-blur-sm border-t border-slate-700 shadow-lg">
        <div className="max-w-4xl mx-auto px-4 py-3">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            {/* Message - Centered */}
            <div className="flex items-center gap-3 text-center">
              <Cookie className="h-5 w-5 text-amber-400 flex-shrink-0" />
              <p className="text-sm text-slate-300">
                Usamos cookies para melhorar sua experiência. Ao continuar, você concorda com nossa{' '}
                <Link 
                  to="/politica-de-privacidade" 
                  target="_blank"
                  className="text-teal-400 hover:text-teal-300 underline underline-offset-2 relative z-50"
                >
                  Política de Privacidade
                </Link>.
              </p>
            </div>

            {/* Actions */}
            <div className="flex items-center gap-2 flex-shrink-0">
              <Button
                onClick={handleAccept}
                size="sm"
                className="bg-teal-600 hover:bg-teal-500 text-white px-6"
                data-testid="cookie-accept-btn"
              >
                Aceitar
              </Button>
              <button
                onClick={handleDismiss}
                className="p-1.5 text-slate-400 hover:text-slate-200 hover:bg-slate-800 rounded-md transition-colors"
                aria-label="Fechar"
                data-testid="cookie-dismiss-btn"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
